import { render, staticRenderFns } from "./personalAssistantBuilder.vue?vue&type=template&id=1f9724ab&scoped=true"
import script from "./personalAssistantBuilder.vue?vue&type=script&lang=js"
export * from "./personalAssistantBuilder.vue?vue&type=script&lang=js"
import style0 from "./personalAssistantBuilder.vue?vue&type=style&index=0&id=1f9724ab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9724ab",
  null
  
)

export default component.exports